export enum SigneeType {
  SIGN = 'sign',
  APPROVE = 'approve'
}
